<template>
  <ListingsFilterRange
    :model-value="modelValue"
    :options="LISTINGS_BEDS_OPTIONS"
    :default-range="DEFAULT_BEDS_RANGE"
    label="No. of bedrooms"
    @update:model-value="handleUpdateModelValue"
  />
</template>

<script lang="ts" setup>
  // Types
  import type { PropType } from 'vue';
  import type { TQueryRange } from '~/misc/listings/types';
  import { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Config
  import { DEFAULT_BEDS_RANGE } from '~/misc/listings/filters/beds/config';
  import { LISTINGS_BEDS_OPTIONS } from '~/misc/listings/config';

  // Utils
  import { eventBus } from '~/misc/utils/event-bus';

  // Components
  import ListingsFilterRange from '~/misc/listings/filters/range/ListingsFilterRange.vue';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: TQueryRange): void;
  }>();

  defineProps({
    modelValue: {
      type: Object as PropType<TQueryRange>,
      default: (): TQueryRange => DEFAULT_BEDS_RANGE,
    },
  });

  const handleUpdateModelValue = (value: TQueryRange) => {
    eventBus.emit(EAnalyticsEvent.DASHBOARD_FILTERS_BEDS_RANGE_CHANGED, { value });

    emit('update:modelValue', value);
  };
</script>
